import React, { useState, useEffect } from 'react';
import { Modal, Button, Radio, Switch, Row, Col } from 'antd';
import PropTypes from 'prop-types';

function SocratesUserModal({
	open,
	onSubmit,
	onCancel,
	title,
	defaultModel,
	testMode,
	disableMask,
}) {
	const [showModal, setShowModal] = useState(false);
	const [selectedModel, setSelectedModel] = useState(defaultModel);
	const [testModeState, setTestModeState] = useState(testMode);

	useEffect(() => {
		setShowModal(open);

		return () => {
			setShowModal(false);
		};
	}, [open]);

	useEffect(() => {
		if (open && defaultModel) {
			setSelectedModel(defaultModel);
		}
	}, [open, defaultModel]);

	useEffect(() => {
		if (open && testMode !== undefined) {
			setTestModeState(testMode);
		}
	}, [open, testMode]);

	const handleSubmit = (e) => {
		e.preventDefault();
		onSubmit(selectedModel, testModeState);
	};

	let footer = [
		<Button
			key='back'
			onClick={() => {
				setShowModal(false);
				if (onCancel) {
					onCancel();
				}
			}}
		>
			Avbryt
		</Button>,
		<Button key='submit' type='primary' onClick={handleSubmit}>
			{'Spara'}
		</Button>,
	];

	const models = ['gpt-4o', 'gpt-5.2'];

	return (
		<Modal
			title={title}
			visible={showModal}
			width={800}
			onCancel={() => {
				setShowModal(false);
				if (onCancel) {
					onCancel();
				}
			}}
			maskClosable={!disableMask}
			footer={footer}
		>
			{open && (
				<div style={{ display: 'flex', justifyContent: 'left', flexDirection: 'column', gap: 16 }}>
					<Row>
						<Col span={4}>
							<span>AI Modell</span>
						</Col>
						<Col span={20}>
							<Radio.Group
								value={selectedModel}
								size='default'
								buttonStyle='solid'
								onChange={(e) => setSelectedModel(e.target.value)}
							>
								{models.map((item, index) => (
									<Radio.Button key={index} value={item}>
										{item}
									</Radio.Button>
								))}
							</Radio.Group>
						</Col>
					</Row>
					<Row style={{ flexDirection: 'row', alignItems: 'center' }}>
						<Col span={4}>
							<span>Test läge</span>
						</Col>
						<Col span={20}>
							<Switch checked={testModeState} onChange={(checked) => setTestModeState(checked)} />
						</Col>
					</Row>
				</div>
			)}
		</Modal>
	);
}

SocratesUserModal.propTypes = {
	open: PropTypes.bool,
	onSubmit: PropTypes.func,
	onCancel: PropTypes.func,
	title: PropTypes.string,
	defaultModel: PropTypes.string,
	testMode: PropTypes.bool,
	disableMask: PropTypes.bool,
};

SocratesUserModal.defaultProps = {
	disableMask: false,
};

export { SocratesUserModal, SocratesUserModal as default };



// WEBPACK FOOTER //
// ./src/components/socratesUserModal.jsx